import { render, staticRenderFns } from "./ModuleMessageSign.vue?vue&type=template&id=b5b39554"
import script from "./ModuleMessageSign.vue?vue&type=script&lang=js"
export * from "./ModuleMessageSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports